export default __webpack_public_path__ + "cad9b7b95fd2f63b9a499683003eab58.woff2";